import { useStyleSheet } from '../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        display: 'grid',
        gridTemplateColumns: '1fr minmax(0, 100%)',
        gap: theme.spacing.primary,
        padding: theme.spacing.primary,
        height: '100vh',
        width: '100vw',
        backgroundColor: theme.palette.background.primary,
        overflow: 'hidden',
      },
    }),
    [],
  );

  return styles;
};
